import { isEditableElementFocused } from './helpers'

/** Roots of surfaces that take over the keyboard while open. Every modal in the
 *  app is a MUI `Modal` (`.MuiModal-root`, which `Popover`/`Menu` also carry) and
 *  every dropdown/calendar is a `Popper`. Tooltips are Poppers too but own no
 *  keys, and one is open whenever the cursor rests on a control that has one. */
const KEYBOARD_OVERLAY_SELECTOR = '.MuiModal-root, .MuiPopper-root:not(.MuiTooltip-popper)'

const isKeyboardOverlayOpen = (): boolean =>
  Boolean(document.querySelector(KEYBOARD_OVERLAY_SELECTOR))

/** ⌘ on a Mac, Ctrl elsewhere — handlers accept either, the way every chord in the app does. */
export const hasCommandModifier = (event: Pick<KeyboardEvent, 'metaKey' | 'ctrlKey'>): boolean =>
  event.metaKey || event.ctrlKey

/**
 * Whether a single-key shortcut (N, ?, J…) must stand down: ⌘/Ctrl/Alt is held,
 * the caret is in a field or rich-text editor, or a dialog, menu or pop-up owns
 * the keyboard. Shift is allowed — `?` needs it.
 */
export const isSingleKeyShortcutBlocked = (
  event: Pick<KeyboardEvent, 'metaKey' | 'ctrlKey' | 'altKey'>,
): boolean =>
  hasCommandModifier(event) || event.altKey || isEditableElementFocused() || isKeyboardOverlayOpen()
